export const SYNC_COUNTER_INCREMENT = 'SYNC_COUNTER_INCREMENT';
export const SYNC_COUNTER_DECREMENT = 'SYNC_COUNTER_DECREMENT';

export const SYNC_ERROR = 'SYNC_ERROR';
